webpackJsonp([1],{

/***/ "+Ozz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[(!_vm.atTop)?_c('div',{staticClass:"h-screen-1/2 xs-hide fixed left-0 right-0 top-0 cursor-n-resize",on:{"click":_vm.prev}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"h-screen-1/2 xs-hide fixed left-0 right-0 bottom-0 cursor-s-resize",on:{"click":_vm.advance}}),_vm._v(" "),_c('div',{ref:"anchors",staticClass:"flex flex-wrap mb-24"},_vm._l((_vm.slides),function(slide,i){return _c('div',{key:i,staticClass:"sm:w-1/2 lg:w-1/3 2xl:w-1/4 index-slide scroll-mt-10"},[_c('div',{staticClass:"grid w-full h-full place-items-center aspect-slide overflow-hidden"},[(_vm.isPost(slide))?_c('figure',{staticClass:"min-h-0 no-change relative group",class:_vm.sizing(slide.acf.thumbnail)},[_c('responsive-image',{staticClass:"max-w-full max-h-full object-contain",attrs:{"src":slide.acf.thumbnail}}),_vm._v(" "),_c('figcaption',{staticClass:"sm:absolute bottom-0 left-0 w-full bg-white transition-all md:opacity-0 group-hover:opacity-100 text-sm"},[_c('p',{staticClass:"mb-0"},[_vm._v(_vm._s(slide.post_title))]),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm.dateFormat(slide.post_date)))]),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(slide.post_content)}})]),_vm._v(" "),_c('v-waypoint',{staticClass:"waypoint",on:{"waypoint-in":function($event){return _vm.waypointIn(i)}}})],1):_c(slide.link ? 'router-link' : 'span',{tag:"component",staticClass:"min-h-0 no-change relative group text-sm",class:_vm.sizing(slide.image),attrs:{"to":_vm.relLink(slide.link)}},[_c('responsive-image',{staticClass:"max-w-full max-h-full object-contain",attrs:{"src":slide.image}}),_vm._v(" "),_c('figcaption',{staticClass:"sm:absolute flex justify-between bottom-0 left-0 w-full bg-white transition-all md:opacity-0 group-hover:opacity-100"},[_c('span',[_vm._v(_vm._s(slide.title))]),_vm._v(" "),(slide.link)?_c('span',[_vm._v("+")]):_vm._e()]),_vm._v(" "),_c('v-waypoint',{staticClass:"waypoint",on:{"waypoint-in":function($event){return _vm.waypointIn(i)}}})],1)],1)])}),0),_vm._v(" "),(_vm.contact)?_c('div',{staticClass:"fixed sm-max-width-footer left-0 bottom-0 pt1 p2 line-height-2"},[_c('p',{staticClass:"m0 lg:text-xl",domProps:{"textContent":_vm._s(_vm.contact)}})]):_vm._e(),_vm._v(" "),_c('IntroScreen',{attrs:{"page":_vm.page}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/CZW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app-footer',
  computed: {
    description: function description() {
      return this.$store.state.description;
    }
  }
});

/***/ }),

/***/ "288I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app-header',
  data: function data() {
    return {
      smMenu: false,
      showProjects: false,
      focussed: null,
      menu: [{ title: 'Information', url: '/information' }, { title: 'News', url: '/news'
        // { title: 'Projects', url: '/projects' }
      }]
    };
  },

  computed: {
    title: function title() {
      return this.$store.state.title;
    },
    notIndex: function notIndex() {
      return this.$route.path !== '/' && this.$route.name !== 'NotFound';
    },
    buttonIcon: function buttonIcon() {
      return this.smMenu ? '×' : '≡';
    },
    projects: function projects() {
      return this.$store.state.projectList;
    },
    experiences: function experiences() {
      return this.$store.state.experienceList;
    },
    route: function route() {
      return this.$route;
    },
    isProject: function isProject() {
      return this.$route.name === 'Experience' || this.$route.name && this.$route.name.indexOf('Project') === 0;
    },
    firstImgSlide: function firstImgSlide() {
      return this.focussed && this.focussed.acf.slides && this.focussed.acf.slides.find(function (s) {
        return s.acf_fc_layout === 'image';
      });
    },
    image: function image() {
      return this.firstImgSlide && this.firstImgSlide.image;
    }
  },
  methods: {
    toggleMenu: function toggleMenu() {
      this.smMenu = !this.smMenu;
      this.focussed = null;
    },
    closeMenu: function closeMenu() {
      this.smMenu = false;
      this.showProjects = false;
    },
    link: function link(slug) {
      return '/projects/' + slug;
    },
    eLink: function eLink(slug) {
      return '/experiences/' + slug;
    },
    focus: function focus(project) {
      this.focussed = project;
    },
    blur: function blur() {
      this.focussed = null;
    },
    thisIsActive: function thisIsActive(project) {
      return this.focussed && project.ID === this.focussed.ID;
    }
  },
  watch: {
    route: function route(newVal) {
      this.closeMenu();
    }
  }
});

/***/ }),

/***/ "42Hy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__("DK6z");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76d8701d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__("+Ozz");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76d8701d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "5yBa":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'slide',
  data: function data() {
    return {
      imgLoaded: false,
      touchStartX: 0,
      touchEnd: 0
    };
  },

  props: {
    data: {
      type: Object,
      required: true
    },
    preload: {
      type: Boolean,
      default: false
    },
    noCaption: Boolean
  },
  computed: {
    isImage: function isImage() {
      return this.data && this.data.acf_fc_layout === 'image';
    },
    text: function text() {
      return !this.isImage && this.data.text;
    },
    title: function title() {
      return this.data.title;
    },
    link: function link() {
      return this.data.link && this.data.link.replace(window.location.origin, '');
    },
    titleEl: function titleEl() {
      return this.link ? 'router-link' : 'span';
    },
    description: function description() {
      if (!this.isImage) return false;
      return this.data.image.caption || this.data.image.description;
    }
  },
  methods: {
    advance: function advance() {
      this.$emit('advance');
    },
    retreat: function retreat() {
      this.$emit('retreat');
    },
    handleTouchStart: function handleTouchStart(event) {
      this.touchStartX = event.changedTouches[0].screenX;
    },
    handleTouchMove: function handleTouchMove(event) {
      this.touchEndX = event.changedTouches[0].screenX;
    },
    handleTouchEnd: function handleTouchEnd() {
      if (this.touchEndX < this.touchStartX - 50) {
        this.advance(); // Swipe left
      } else if (this.touchEndX > this.touchStartX + 50) {
        this.retreat(); // Swipe right (implement retreat if needed)
      }
    }
  },
  render: function render(createElement) {
    var _this = this;

    if (this.isImage) {
      var kids = [createElement('responsive-image', {
        props: {
          src: this.data.image,
          preload: this.preload,
          background: false
        },
        nativeOn: {
          click: this.advance,
          lazybeforeunveil: function lazybeforeunveil() {
            _this.imgLoaded = true;
          },
          touchstart: this.handleTouchStart,
          touchmove: this.handleTouchMove,
          touchend: this.handleTouchEnd
        }
      })];
      if (this.data.title) {
        kids.push(createElement('figcaption', {
          'class': ['figcaption line-height-3', { 'opacity-0': !this.imgLoaded }]
        }, [createElement(this.titleEl, {
          props: { to: this.link }
        }, this.data.title)]));
      }
      if (this.description && !this.noCaption) {
        kids.push(createElement('figcaption', {
          'class': 'm0 left-align absolute left-0 top-100'
        }, this.description));
      }
      return createElement('figure', {
        'class': 'm0 relative'
      }, kids);
    } else {
      return createElement('div', {
        'class': 'max-width-3 h4 relative z3',
        domProps: {
          innerHTML: this.text
        }
      });
    }
  }
};

/***/ }),

/***/ "6mOd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"overflow-x-hidden",attrs:{"id":"app"}},[_c('app-header',{staticClass:"p2"}),_vm._v(" "),_c('main',{staticClass:"mt4 px2 clearfix"},[_c('router-view')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6oYQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"relative gallery-height flex items-center",class:{ 'aside lg:block': _vm.projectView }},[_vm._l((_vm.images),function(slide,i){return [_c('transition',{attrs:{"name":"custom-classes-transition","enter-active-class":_vm.animIn,"leave-active-class":_vm.animOut}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible(i)),expression:"visible(i)"}],staticClass:"flex justify-around items-center slide",class:{ 'cursor-s-resize': _vm.projectView },on:{"pointerdown":_vm.advance}},[_c('slide',{attrs:{"data":slide,"preload":_vm.preloadFirst(i),"no-caption":_vm.noCaption},on:{"advance":_vm.next,"retreat":_vm.previous}})],1)])]}),_vm._v(" "),(_vm.hasNext && _vm.showNav)?_c('nav',{staticClass:"hide fixed right-0 bottom-0 mr1 no-select"},[_c('a',{staticClass:"py2 px1 inline-block pointer",on:{"click":_vm.previous}},[_c('img',{staticClass:"arr",attrs:{"src":__webpack_require__("CMZO"),"width":"21"}})]),_vm._v(" "),_c('a',{staticClass:"py2 px1 inline-block pointer",on:{"click":_vm.next}},[_c('img',{staticClass:"arr",attrs:{"src":__webpack_require__("Wo66"),"width":"21"}})])]):_vm._e(),_vm._v(" "),(_vm.hasNext && !_vm.projectView)?_c('div',{staticClass:"z2 large-slide-nav absolute no-select left-0 top-0 bottom-0 cursor-left xs-hide",on:{"click":_vm.previous}}):_vm._e(),_vm._v(" "),(_vm.hasNext && !_vm.projectView)?_c('div',{staticClass:"z2 large-slide-nav absolute no-select right-0 top-0 bottom-0 cursor-right xs-hide",on:{"click":_vm.next}}):_vm._e()],2),_vm._v(" "),(_vm.images.length > 1 && _vm.projectView && !_vm.top)?_c('div',{staticClass:"hidden lg:block fixed top-0 right-0 project-prev cursor-n-resize",on:{"click":_vm.scrollUp}}):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CMVY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"m0 h4 regular"},[_vm._v("404")]),_vm._v(" "),_c('p',{staticClass:"m0"},[_vm._v("Not found")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CMZO":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/larr.f590225.svg";

/***/ }),

/***/ "CjOB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lg-flex justify-around"},[_c('div',{staticClass:"fixed left-0 bottom-0 p2 xs-hide sm-hide md-hide"},[_c('h1',{staticClass:"h4 m0 regular line-height-2"},[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('gallery',{key:_vm.slug,attrs:{"data":_vm.images,"preload":true,"project-view":true}}),_vm._v(" "),(_vm.info)?_c('div',{staticClass:"lg-px2 lg-py0 project-info overflow-auto"},[_c('p',{staticClass:"lg-hide pt1 line-height-2"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',{staticClass:"justify",domProps:{"innerHTML":_vm._s(_vm.info.text)}})]):_vm._e(),_vm._v(" "),(_vm.nextProject)?_c('div',{staticClass:"fixed right-0 bottom-0 p2 xs-hide sm-hide md-hide"},[_c('router-link',{staticClass:"h4 m0 regular line-height-2",attrs:{"to":("/projects/" + (_vm.nextProject.post_name))}},[_vm._v("Next project")])],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "DDYG":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'responsive-image',
  props: {
    src: {
      type: Object,
      required: true
    },
    maxSize: Number,
    background: Boolean,
    preload: {
      type: Boolean,
      default: false
    }
  },
  render: function render(createElement) {
    if (!this.src) {
      return createElement('span', {
        'class': 'px3 py2 bg-white rounded border border-silver'
      }, 'No image :(');
    }
    var srcset = [this.src.sizes.thumbnail + ' 300w', this.src.sizes.medium + ' 620w', this.src.sizes.medium_large + ' 768w', this.src.sizes.large + ' 1600w', this.src.url + ' 2400w'];
    if (this.maxSize) {
      srcset = srcset.slice(0, this.maxSize);
    }
    var classList = this.preload ? 'lazyload visible' : 'lazyload';
    if (this.background) {
      return createElement('div', {
        'class': [classList, 'bg-contain bg-no-repeat bg-center'],
        ref: 'picture',
        attrs: {
          'data-bgset': srcset.join(', ')
        }
      });
    }
    return createElement('img', {
      'class': classList,
      ref: 'picture',
      attrs: {
        // src: this.src.url
        'data-srcset': srcset.join(', '),
        sizes: '1600px',
        width: this.src.width,
        height: this.src.height
      }
    });
  },

  watch: {
    src: function src(newVal) {
      if (newVal) {
        var classes = this.$refs.picture.classList;
        classes.toggle('lazyloaded');
        classes.toggle('lazyload');
      }
    }
  }
};

/***/ }),

/***/ "DK6z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fecha__ = __webpack_require__("ldx2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fecha___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_fecha__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__store__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Gallery__ = __webpack_require__("sl25");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_IntroScreen__ = __webpack_require__("NVdj");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'index',
  data: function data() {
    return {
      y: 0,
      listener: 0,
      current: 0
    };
  },

  computed: {
    atTop: function atTop() {
      return this.y < 80;
    },
    page: function page() {
      return this.$store.state.pages['home'] || {};
    },
    contact: function contact() {
      return this.page.acf && this.page.acf.contact;
    },
    news: function news() {
      return this.$store.state.news || [];
    },
    slides: function slides() {
      if (!this.page.acf) return [];

      var list = this.page.acf.slides.slice();
      // distribute news items
      this.news.forEach(function (n, i) {
        var idx = i * 5 + 4;
        if (idx >= list.length) return;
        list.splice(idx, 0, n);
      });
      return list;
    },
    anchors: function anchors() {
      return this.$refs.anchors.children;
    }
  },
  methods: {
    dateFormat: function dateFormat(d) {
      return __WEBPACK_IMPORTED_MODULE_1_fecha___default.a.format(new Date(d), 'DD.MM.YYYY');
    },
    sizing: function sizing(img) {
      if (!img) return '';

      return img.width > img.height ? 'h-auto w-full' : 'h-full w-auto';
    },
    isPost: function isPost(item) {
      return item.post_type === 'post';
    },
    relLink: function relLink() {
      var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      if (typeof str !== 'string') return '';
      return str.replace(window.location.origin, '');
    },
    waypointIn: function waypointIn(id) {
      if (id % 3) return;
      this.current = id;
    },
    prev: function prev() {
      for (var i = 0; i < this.anchors.length; i++) {
        if (this.anchors[i].getBoundingClientRect().top > 0) {
          if (i < 4) {
            window.scrollTo({
              top: 0,
              behavior: 'smooth'
            });
            return;
          }
          this.anchors[i - 4].scrollIntoView({
            block: 'start',
            behavior: 'smooth'
          });
          return;
        }
      }
    },
    advance: function advance() {
      var h = window.innerHeight * 0.66;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.anchors), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var el = _step.value;

          if (el.getBoundingClientRect().top > h) {
            el.scrollIntoView({
              block: 'start',
              behavior: 'smooth'
            });
            return;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  },
  beforeRouteEnter: function beforeRouteEnter(_to, _from, next) {
    __WEBPACK_IMPORTED_MODULE_2__store___default.a.dispatch('loadHomePage').then(function () {
      next();
    });
  },
  mounted: function mounted() {
    var _this = this;

    this.listener = window.addEventListener('scroll', function () {
      _this.y = window.scrollY;
    });
  },
  onUnmounted: function onUnmounted() {
    window.removeEventListener(this.listener);
  },

  components: { Gallery: __WEBPACK_IMPORTED_MODULE_3__components_Gallery__["a" /* default */], IntroScreen: __WEBPACK_IMPORTED_MODULE_4__components_IntroScreen__["a" /* default */] }

  // function shuffle (a) {
  //   for (let i = a.length - 1; i > 0; i--) {
  //     const j = Math.floor(Math.random() * (i + 1))
  //     ;[a[i], a[j]] = [a[j], a[i]]
  //   }
  //   return a
  // }

});

/***/ }),

/***/ "EZvQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_News_vue__ = __webpack_require__("mvlf");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36244424_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_News_vue__ = __webpack_require__("FmkY");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_News_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36244424_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_News_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "FYrl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppPage_vue__ = __webpack_require__("WCIu");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12fbd484_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppPage_vue__ = __webpack_require__("MUjn");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12fbd484_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "FmkY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-12 md:mb-36"},[(_vm.current > 1)?_c('div',{staticClass:"h-screen-1/2 hidden md:block fixed left-0 right-0 top-0 cursor-n-resize",on:{"click":_vm.prev}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"h-screen-1/2 hidden md:block fixed left-0 right-0 bottom-0 cursor-s-resize",on:{"click":_vm.advance}}),_vm._v(" "),_c('div',{ref:"anchors",staticClass:"md:flex flex-wrap md:-mt-8"},_vm._l((_vm.posts),function(post,index){return _c('article',{staticClass:"md:w-1/2 desk-news md:px-8 scroll-mt-screen-1/2 pb3 md:pb-0",attrs:{"id":post.domId,"data-idx":index}},[_c('div',{staticClass:"mb3 sm-mb4 max-w-md md:mx-[2vw] relative"},[(post.acf.thumbnail)?_c('figure',{staticClass:"m0 pb2 desk-img"},[_c('responsive-image',{attrs:{"src":post.acf.thumbnail,"alt":post.title.rendered}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"relative"},[_c('h2',{staticClass:"h4 m0 regular flex justify-between"},[_c('span',{staticClass:"underline"},[_vm._v(_vm._s(post.title.rendered))]),_vm._v(" "),_c('span',{},[_vm._v(_vm._s(_vm.dateFormat(post.date)))])]),_vm._v(" "),_c('div',{staticClass:"relative"},[_c('div',{staticClass:"justify",domProps:{"innerHTML":_vm._s(post.content.rendered)}}),_vm._v(" "),_c('v-waypoint',{staticClass:"waypoint",on:{"waypoint-in":function($event){return _vm.waypointIn(index)}}})],1)])])])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HKjq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_debounce__ = __webpack_require__("HhAh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_partials_Slide__ = __webpack_require__("5yBa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_partials_Slide___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_partials_Slide__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'gallery',
  data: function data() {
    return {
      idx: 0,
      forward: true,
      firstLoad: true,
      top: true
    };
  },

  props: {
    data: Array,
    projectView: Boolean,
    noCaption: Boolean,
    preload: {
      type: Boolean,
      default: false
    },
    showNav: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    slides: function slides() {
      return this.data || this.$store.state.currentProject.acf.slides || [];
    },
    images: function images() {
      return this.slides.filter(function (i) {
        return i.acf_fc_layout === 'image';
      });
    },
    hasNext: function hasNext() {
      return this.images.length > 1;
    },
    current: function current() {
      return this.images[this.idx];
    },
    last: function last() {
      return this.images.length - 1;
    },
    animIn: function animIn() {
      return !this.firstLoad && this.forward ? 'animated fadeInRight' : 'animated fadeInLeft';
    },
    animOut: function animOut() {
      return !this.firstLoad && this.forward ? 'animated fadeOutLeft' : 'animated fadeOutRight';
    }
  },
  methods: {
    visible: function visible(idx) {
      if (this.projectView) {
        var match = window.matchMedia('(min-width: 64em)').matches;
        if (match) {
          return true;
        }
      }
      return idx === this.idx;
    },
    next: function next() {
      var _this = this;

      this.forward = true;
      this.$nextTick(function () {
        if (_this.idx < _this.last) _this.idx++;else _this.idx = 0;
      });
    },
    previous: function previous() {
      var _this2 = this;

      this.forward = false;
      this.$nextTick(function () {
        if (_this2.idx > 0) _this2.idx--;else _this2.idx = _this2.last;
      });
    },
    refresh: function refresh() {
      this.$forceUpdate();
    },
    preloadFirst: function preloadFirst(idx) {
      return this.preload && idx === 0;
    },
    advance: function advance(e) {
      // console.log(e)
      if (e && e.pointerType === 'touch') return;
      if (!this.projectView) return;

      var slide = e.currentTarget;
      var end = 0;
      if (slide.nextElementSibling.classList.contains('slide')) {
        end = slide.nextElementSibling.getBoundingClientRect().top + window.pageYOffset;
      }

      var duration = 450;
      var clock = Date.now();

      var requestAnimationFrame = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || function (fn) {
        window.setTimeout(fn, 15);
      };

      var step = function step() {
        var elapsed = Date.now() - clock;
        var position = end;
        if (elapsed < duration) {
          position = window.pageYOffset + (end - window.pageYOffset) * easeInOutCubic(elapsed / duration);
          requestAnimationFrame(step);
        }
        window.scroll(0, position);
      };
      step();
    },
    scrollUp: function scrollUp() {
      if (!this.projectView) return;
      // find slide that is in view
      var slides = document.querySelectorAll('.slide');
      if (!slides) return;
      var slide = null;
      for (var i = 0; i < slides.length; i++) {
        var rect = slides[i].getBoundingClientRect();
        if (rect.top >= 0 && rect.top <= window.innerHeight / 2 || rect.bottom <= window.innerHeight && rect.bottom >= window.innerHeight / 2) {
          slide = slides[i];
          break;
        }
      }
      if (!slide) return;

      var end = 0;
      if (slide.previousElementSibling) {
        end = slide.previousElementSibling.getBoundingClientRect().top + window.pageYOffset;
      }

      var duration = 450;
      var clock = Date.now();

      var requestAnimationFrame = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || function (fn) {
        window.setTimeout(fn, 15);
      };

      var step = function step() {
        var elapsed = Date.now() - clock;
        var position = end;
        if (elapsed < duration) {
          position = window.pageYOffset + (end - window.pageYOffset) * easeInOutCubic(elapsed / duration);
          requestAnimationFrame(step);
        }
        window.scroll(0, position);
      };
      step();
    },
    listen: function listen() {},
    onScroll: function onScroll() {
      this.top = window.scrollY < window.innerHeight / 2;
    }
  },
  watch: {
    slides: function slides(newVal) {
      var _this3 = this;

      this.firstLoad = true;
      this.$nextTick(function () {
        _this3.idx = 0;
        _this3.firstLoad = false;
      });
    }
  },
  mounted: function mounted() {
    var _this4 = this;

    this.listen = __WEBPACK_IMPORTED_MODULE_0_debounce___default()(this.refresh, 100);
    window.addEventListener('resize', this.listen);
    this.$nextTick(function () {
      _this4.firstLoad = false;
    });
    window.addEventListener('scroll', this.onScroll);
  },
  destroyed: function destroyed() {
    window.removeEventListener('resize', this.listen);
    window.removeEventListener('scroll', this.onScroll);
  },

  components: { Slide: __WEBPACK_IMPORTED_MODULE_1__components_partials_Slide___default.a }
});

function easeInOutCubic(t) {
  return t < 0.5 ? 2 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
}

/***/ }),

/***/ "IcnI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__("/5sW");

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__("NYxO");

var _vuex2 = _interopRequireDefault(_vuex);

var _state = __webpack_require__("lwq5");

var _state2 = _interopRequireDefault(_state);

var _actions = __webpack_require__("mUbh");

var _actions2 = _interopRequireDefault(_actions);

var _mutations = __webpack_require__("ukYY");

var _mutations2 = _interopRequireDefault(_mutations);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vuex2.default);

exports.default = new _vuex2.default.Store({
  state: _state2.default,
  actions: _actions2.default,
  mutations: _mutations2.default,
  getters: {
    nextProject: function nextProject(_ref) {
      var currentProject = _ref.currentProject,
          projectList = _ref.projectList;

      if (!currentProject || !currentProject.ID || !projectList.length) return;

      var id = currentProject.ID;
      var idx = projectList.findIndex(function (p) {
        return p.ID === id;
      });
      var wrap = (idx + 1) % projectList.length;

      return projectList[wrap];
    }
  }
});

/***/ }),

/***/ "Kw7b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__store__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Gallery__ = __webpack_require__("sl25");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'project',
  metaInfo: function metaInfo() {
    return {
      title: this.title,
      titleTemplate: '%s · Maich Swift Architects'
    };
  },

  computed: {
    slug: function slug() {
      return this.$route.params.slug;
    },
    project: function project() {
      // return store.state.currentProject
      return __WEBPACK_IMPORTED_MODULE_0__store___default.a.state.projects[this.slug];
    },
    slides: function slides() {
      if (!this.project) return [];
      return this.project.acf.slides || [];
    },
    images: function images() {
      return this.slides.filter(function (i) {
        return i.acf_fc_layout === 'image';
      });
    },
    info: function info() {
      return this.slides.find(function (i) {
        return i.acf_fc_layout === 'text';
      });
    },
    title: function title() {
      return this.project.post_title || this.project.title.rendered;
    },
    nextProject: function nextProject() {
      return __WEBPACK_IMPORTED_MODULE_0__store___default.a.getters.nextProject;
    }
  },
  beforeRouteEnter: function beforeRouteEnter(to, _from, next) {
    var slug = to.params.slug;
    var type = to.meta.type;

    __WEBPACK_IMPORTED_MODULE_0__store___default.a.dispatch('getProject', { slug: slug, type: type }).then(function () {
      next();
    });
  },
  beforeRouteUpdate: function beforeRouteUpdate(to, _from, next) {
    var slug = to.params.slug;
    var type = to.meta.type;

    __WEBPACK_IMPORTED_MODULE_0__store___default.a.dispatch('getProject', { slug: slug, type: type }).then(function () {
      setTimeout(next, 100);
    });
  },

  components: { Gallery: __WEBPACK_IMPORTED_MODULE_1__components_Gallery__["a" /* default */] }
});

/***/ }),

/***/ "M3kg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2bada717_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("6mOd");
function injectStyle (ssrContext) {
  __webpack_require__("M3kg")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2bada717_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "MUjn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.page)?_c('div',[_c('h1',{staticClass:"text-3xl font-normal"},[_vm._v(_vm._s(_vm.page.post_title))]),_vm._v(" "),_c('div',{staticClass:"max-w-prose"},[_c('div',{staticClass:"rendered",domProps:{"innerHTML":_vm._s(_vm.page.content.rendered)}})])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NHnr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__("/5sW");

var _vue2 = _interopRequireDefault(_vue);

var _App = __webpack_require__("M93x");

var _App2 = _interopRequireDefault(_App);

var _router = __webpack_require__("YaEn");

var _router2 = _interopRequireDefault(_router);

var _store = __webpack_require__("IcnI");

var _store2 = _interopRequireDefault(_store);

var _ResponsiveImage = __webpack_require__("DDYG");

var _ResponsiveImage2 = _interopRequireDefault(_ResponsiveImage);

var _vueAnalytics = __webpack_require__("AYPi");

var _vueAnalytics2 = _interopRequireDefault(_vueAnalytics);

var _vueSmoothScroll = __webpack_require__("lPdT");

var _vueSmoothScroll2 = _interopRequireDefault(_vueSmoothScroll);

var _vueWaypoint = __webpack_require__("9OOc");

var _vueWaypoint2 = _interopRequireDefault(_vueWaypoint);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.config.productionTip = "production" === 'production';

_vue2.default.component('responsive-image', _ResponsiveImage2.default);

_vue2.default.use(_vueAnalytics2.default, {
  id: 'UA-109724881-1',
  router: _router2.default
});

_vue2.default.use(_vueSmoothScroll2.default);

_vue2.default.use(_vueWaypoint2.default);

/* eslint-disable no-new */
new _vue2.default({
  store: _store2.default,
  router: _router2.default,

  el: '#app',
  render: function render(h) {
    return h(_App2.default);
  }
});

/***/ }),

/***/ "NVdj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IntroScreen_vue__ = __webpack_require__("zIgt");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c2487b54_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IntroScreen_vue__ = __webpack_require__("NtGL");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IntroScreen_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c2487b54_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IntroScreen_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NtGL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Transition',{attrs:{"name":"fade"}},[(_vm.visible)?_c('div',{staticClass:"fixed z-50 top-0 left-0 w-full h-full bg-white",style:({ color: _vm.color }),on:{"click":function($event){_vm.visible = false}}},[(_vm.bg)?_c('div',{staticClass:"absolute top-0 left-0 w-full h-full z-0"},[_c('responsive-image',{staticClass:"w-full h-full object-cover",attrs:{"src":_vm.bg}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"w-full h-full grid place-items-center"},[(_vm.image)?_c('div',{staticClass:"w-72 max-w-full",class:{ spin: _vm.spin }},[_c('responsive-image',{staticClass:"w-full h-auto",attrs:{"src":_vm.image}})],1):_vm._e()]),_vm._v(" "),(_vm.text)?_c('div',{staticClass:"absolute bottom-0 left-0 w-full text-center",on:{"click":function($event){$event.stopPropagation();}}},[_c('div',{staticClass:"lg:text-xl",domProps:{"innerHTML":_vm._s(_vm.text)}})]):_vm._e()]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Oh4D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__store__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'information',
  metaInfo: { title: 'Information · Maich Swift Architects' },
  data: function data() {
    return {
      y: 0,
      listener: 0,
      current: ''
    };
  },

  computed: {
    atTop: function atTop() {
      return this.y < 80;
    },
    slug: function slug() {
      return this.$route.meta.slug;
    },
    page: function page() {
      return this.$store.state.pages[this.slug] || {};
    },
    rows: function rows() {
      if (!this.page.acf) return [];

      return this.page.acf.rows.map(function (p) {
        p.id = p.title.toLowerCase().replace(/\s/g, '-');
        return p;
      });
    },
    contact: function contact() {
      return this.$store.state.pages['home'] && this.$store.state.pages['home'].acf && this.$store.state.pages['home'].acf.contact;
    },
    anchors: function anchors() {
      return this.$refs.anchors;
    }
  },
  methods: {
    to: function to(id) {
      if (!id) return;
      var el = document.getElementById(id);

      if (el) {
        el.scrollIntoView({
          block: 'start',
          behavior: 'smooth'
        });
      }
    },
    anchor: function anchor(id) {
      return '#' + id;
    },
    active: function active(id) {
      return id === this.current && 'router-link-active';
    },
    waypointIn: function waypointIn(id) {
      this.current = id;
    },
    prev: function prev() {
      for (var i = this.anchors.length - 1; i > 0; i--) {
        if (this.anchors[i].getBoundingClientRect().top < 0) {
          this.anchors[i].scrollIntoView({
            block: 'start',
            behavior: 'smooth'
          });
          return;
        }

        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }
    },
    advance: function advance() {
      var headings = document.querySelectorAll('.cms h2');
      var h = window.innerHeight * 0.8;

      var ne = void 0;
      var nt = void 0;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(headings), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var h2 = _step.value;

          var ntt = h2.getBoundingClientRect().top;
          if (ntt > h * 0.4) {
            ne = h2;
            nt = ntt;
            break;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.anchors), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var el = _step2.value;

          var et = el.getBoundingClientRect().top;
          if (nt < et && ne) {
            ne.scrollIntoView({
              block: 'start',
              behavior: 'smooth'
            });
            return;
          }
          if (et > h) {
            el.scrollIntoView({
              block: 'start',
              behavior: 'smooth'
            });
            return;
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    var slug = to.meta.slug;

    __WEBPACK_IMPORTED_MODULE_1__store___default.a.dispatch('getPage', slug).then(function () {
      next();
    });
  },
  mounted: function mounted() {
    var _this = this;

    console.log(this.page);
    this.listener = window.addEventListener('scroll', function () {
      _this.y = window.scrollY;
    });
  },
  onUnmounted: function onUnmounted() {
    window.removeEventListener(this.listener);
  }
});

/***/ }),

/***/ "SyDD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppHeader_vue__ = __webpack_require__("288I");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_055ad397_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppHeader_vue__ = __webpack_require__("nnUm");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_055ad397_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppHeader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TJQs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"display-none"},[_c('p',{staticClass:"m0"},[_vm._v(_vm._s(_vm.description))]),_vm._v(" "),_c('small',[_vm._v("© 2017 Maich Swift Architects Ltd")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "TYs3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppFooter_vue__ = __webpack_require__("/CZW");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_735dc974_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppFooter_vue__ = __webpack_require__("TJQs");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppFooter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_735dc974_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppFooter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "WBYr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Information_vue__ = __webpack_require__("Oh4D");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4147b1a5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Information_vue__ = __webpack_require__("gatj");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Information_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4147b1a5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Information_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "WCIu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__store__);
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AppPage',
  computed: {
    slug: function slug() {
      return this.$route.meta.slug;
    },
    page: function page() {
      return this.$store.state.pages[this.slug] || {};
    }
  },
  beforeRouteEnter: function beforeRouteEnter(to, _from, next) {
    var slug = to.meta.slug;

    __WEBPACK_IMPORTED_MODULE_0__store___default.a.dispatch('getPage', slug).then(function () {
      next();
    });
  },
  mounted: function mounted() {
    console.log(this.page);
  }
});

/***/ }),

/***/ "Wo66":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/rarr.1f96b78.svg";

/***/ }),

/***/ "WoGI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'not-found'
});

/***/ }),

/***/ "YaEn":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__("/5sW");

var _vue2 = _interopRequireDefault(_vue);

var _vueRouter = __webpack_require__("/ocq");

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _vueMeta = __webpack_require__("p3jY");

var _vueMeta2 = _interopRequireDefault(_vueMeta);

var _Index = __webpack_require__("42Hy");

var _Index2 = _interopRequireDefault(_Index);

var _Project = __webpack_require__("wa3q");

var _Project2 = _interopRequireDefault(_Project);

var _Information = __webpack_require__("WBYr");

var _Information2 = _interopRequireDefault(_Information);

var _News = __webpack_require__("EZvQ");

var _News2 = _interopRequireDefault(_News);

var _NotFound = __webpack_require__("YcJa");

var _NotFound2 = _interopRequireDefault(_NotFound);

var _AppPage = __webpack_require__("FYrl");

var _AppPage2 = _interopRequireDefault(_AppPage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vueRouter2.default);
// import Projects from '@/components/Projects'

_vue2.default.use(_vueMeta2.default);

exports.default = new _vueRouter2.default({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'Index',
    component: _Index2.default
  }, {
    path: '/projects',
    name: 'Projects',
    meta: { slug: 'projects' },
    component: _Information2.default
    // component: Projects
  }, {
    path: '/projects/:slug',
    name: 'Project',
    component: _Project2.default,
    meta: { type: 'project' }
  }, {
    path: '/experiences/:slug',
    name: 'Experience',
    component: _Project2.default,
    meta: { type: 'experience' }
  }, {
    path: '/information',
    name: 'Information',
    meta: { slug: 'information' },
    component: _Information2.default
  }, {
    path: '/privacy-policy',
    name: 'PrivacyPolicy',
    meta: { slug: 'privacy-policy' },
    component: _AppPage2.default
  }, {
    path: '/news',
    name: 'News',
    component: _News2.default
  }, {
    path: '/news/:slug',
    name: 'Post',
    component: _News2.default
  }, {
    path: '*',
    name: 'NotFound',
    component: _NotFound2.default
  }],
  scrollBehavior: function scrollBehavior(_to, _from, savedPosition) {
    // return new Promise((resolve) => {
    //   setTimeout(() => {
    //     if (savedPosition) {
    //       resolve(savedPosition)
    //     } else {
    //       resolve({ x: 0, y: 0 })
    //     }
    //   }, 1000)
    // })
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
});

/***/ }),

/***/ "YcJa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotFound_vue__ = __webpack_require__("WoGI");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9e12a672_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotFound_vue__ = __webpack_require__("CMVY");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotFound_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9e12a672_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotFound_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "gatj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.atTop)?_c('div',{staticClass:"h-screen-1/2 hidden md:block fixed left-0 right-0 top-0 cursor-n-resize z-5",on:{"click":_vm.prev}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"h-screen-1/2 hidden md:block fixed left-0 right-0 bottom-0 cursor-s-resize z-5",on:{"click":_vm.advance}}),_vm._v(" "),_c('nav',{staticClass:"z-10 xs-hide sm-hide md-fixed left-0 top-0 mt4 ml2"},[_c('ul',{staticClass:"list-reset m0"},_vm._l((_vm.rows),function(row){return _c('li',{staticClass:"h3 max-w-list",class:_vm.active(row.id)},[_c('a',{attrs:{"href":_vm.anchor(row.id)},on:{"click":function($event){$event.preventDefault();return _vm.to(row.id)}}},[_vm._v(_vm._s(row.title))])])}),0)]),_vm._v(" "),_c('article',{staticClass:"infos mb-12"},[_vm._l((_vm.rows),function(row){return [_c('section',{ref:"anchors",refInFor:true,staticClass:"pb3 sm-pb4 md-info-height md-flex flex-wrap items-center relative scroll-mt-14",attrs:{"id":row.id}},[_c('div',{staticClass:"w-full max-width-2 mx-auto relative z-10"},[_c('h2',{staticClass:"h4 regular underline m0 md-hide lg-hide"},[_vm._v(_vm._s(row.title))]),_vm._v(" "),_c('div',{staticClass:"relative cms"},[_c('div',{staticClass:"justify",domProps:{"innerHTML":_vm._s(row.content)}})])]),_vm._v(" "),_c('v-waypoint',{staticClass:"absolute waypoint",on:{"waypoint-in":function($event){return _vm.waypointIn(row.id)}}}),_vm._v(" "),_c('v-waypoint',{staticClass:"absolute waypoint-b",on:{"waypoint-in":function($event){return _vm.waypointIn(row.id)}}}),_vm._v(" "),(row.images && row.images[0])?_c('div',{staticClass:"block lg:absolute right-0 top-0 w-aside mx-auto mt-4"},[_c('div',{staticClass:"my-8 lg:my-0 lg:aspect-square w-auto h-auto max-width-2 lg:max-w-full max-h-full mx-auto object-contain sm:px-8 lg:px-0"},[_c('responsive-image',{staticClass:"w-full h-full object-contain",attrs:{"src":row.images[0]}})],1)]):_vm._e(),_vm._v(" "),(row.images && row.images[1])?_c('div',{staticClass:"block lg:absolute left-0 bottom-24 w-aside mx-auto"},[_c('div',{staticClass:"my-8 lg:my-0 lg:aspect-square w-auto h-auto max-width-2 lg:max-w-full max-h-full mx-auto object-contain sm:px-8 lg:px-0"},[_c('responsive-image',{staticClass:"w-full h-full object-contain",attrs:{"src":row.images[1]}})],1)]):_vm._e(),_vm._v(" "),(row.images && row.images[2])?_c('div',{staticClass:"block lg:absolute right-0 bottom-24 w-aside mx-auto"},[_c('div',{staticClass:"my-8 lg:my-0 lg:aspect-square w-auto h-auto max-width-2 lg:max-w-full max-h-full mx-auto object-contain sm:px-8 lg:px-0"},[_c('responsive-image',{staticClass:"w-full h-full object-contain",attrs:{"src":row.images[2]}})],1)]):_vm._e()],1)]})],2),_vm._v(" "),(_vm.contact)?_c('div',{staticClass:"sm-fixed sm-max-width-footer left-0 bottom-0 pt1 sm-p2 z-10"},[_c('p',{staticClass:"m0 lg:text-xl",domProps:{"textContent":_vm._s(_vm.contact)}})]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lPdT":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = __webpack_require__("pFYg");

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  install: function install(Vue) {
    Vue.directive('smooth-scroll', {
      inserted: function inserted(el, binding) {
        if ((typeof window === 'undefined' ? 'undefined' : (0, _typeof3.default)(window)) !== 'object' || window.scrollY === void 0) return;

        el.addEventListener('click', function (ev) {
          var scrollTo = document.getElementById(this.hash.substring(1));
          if (!scrollTo) return;

          ev.preventDefault();

          var duration = binding.value && binding.value.duration ? binding.value['duration'] : 450;

          var offset = binding.value && binding.value.offset ? binding.value['offset'] : 0;

          var clock = Date.now();

          var end = scrollTo.nodeName === 'HTML' ? -window.scrollY : scrollTo.getBoundingClientRect().top + window.scrollY;

          end += offset;

          var requestAnimationFrame = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || function (fn) {
            window.setTimeout(fn, 15);
          };

          var step = function step() {
            var elapsed = Date.now() - clock;
            var position = end;
            if (elapsed < duration) {
              position = window.scrollY + (end - window.scrollY) * easeInOutCubic(elapsed / duration);
              requestAnimationFrame(step);
            }
            window.scroll(0, position);
          };
          step();
        });
      }
    });
  }
};


function easeInOutCubic(t) {
  return t < 0.5 ? 2 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
}

/***/ }),

/***/ "lwq5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var preloaded = window.maichSwift || {};

exports.default = {
  title: preloaded.title,
  description: preloaded.description,
  projectList: preloaded.projectList || [],
  experienceList: preloaded.experienceList || [],
  projects: projectSlugs(),
  currentProject: {},
  news: preloaded.news || [],

  pages: {
    home: preloaded.homepage || {}
  },
  currentPage: {},
  posts: [],

  introVisible: true
};


function projectSlugs() {
  var keyed = {};
  preloaded.projectList.forEach(function (p) {
    keyed[p.post_name] = p;
  });

  return keyed;
}

/***/ }),

/***/ "mUbh":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var API_BASE = '/wp-json/wp/v2/';

exports.default = {
  getProjects: function getProjects(_ref) {
    var commit = _ref.commit;

    return _axios2.default.get(apiUrl('project')).then(function (_ref2) {
      var data = _ref2.data;

      commit('GOT_PROJECTS', data);
    });
  },
  getProject: function getProject(_ref3, _ref4) {
    var commit = _ref3.commit,
        state = _ref3.state;
    var slug = _ref4.slug,
        type = _ref4.type;

    // console.log('get', slug, type, state.projects)
    if (state.projects[slug]) {
      commit('SELECT_PROJECT', slug);
      return _promise2.default.resolve();
    }
    return _axios2.default.get(apiUrl(type), { params: { slug: slug } }).then(function (_ref5) {
      var data = _ref5.data;

      if (!data.length) throw new Error('404 Not Found');
      var post = data[0];
      commit('GOT_PROJECT', post);
      commit('SELECT_PROJECT', slug);
    });
  },
  loadHomePage: function loadHomePage(_ref6) {
    var commit = _ref6.commit,
        state = _ref6.state;

    if (state.pages['home']) {
      commit('SELECT_PAGE', 'home');
      return _promise2.default.resolve();
    } else {
      return _promise2.default.reject();
    }
  },
  getPage: function getPage(_ref7, slug) {
    var commit = _ref7.commit,
        state = _ref7.state;

    if (state.pages[slug]) {
      commit('SELECT_PAGE', slug);
      return _promise2.default.resolve();
    }
    return _axios2.default.get('/wp-json/ms/v1/pages/' + slug).then(function (_ref8) {
      var data = _ref8.data;

      commit('GOT_PAGE', data);
    });
  },
  getPosts: function getPosts(_ref9) {
    var commit = _ref9.commit,
        state = _ref9.state;

    if (state.posts.length) {
      return _promise2.default.resolve();
    }
    return _axios2.default.get(apiUrl('posts'), {
      params: { per_page: 100 }
    }).then(function (_ref10) {
      var data = _ref10.data;

      commit('GOT_POSTS', data);
    });
  }
};


function apiUrl(endpoint) {
  return API_BASE + endpoint;
}

/***/ }),

/***/ "mvlf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fecha__ = __webpack_require__("ldx2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fecha___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_fecha__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__store__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'news',
  metaInfo: { title: 'News · Maich Swift Architects' },
  data: function data() {
    return { current: null };
  },

  computed: {
    posts: function posts() {
      return this.$store.state.posts.map(function (p) {
        p.domId = p.slug + '-' + p.id;
        return p;
      });
    },
    anchors: function anchors() {
      return this.$refs.anchors.children;
    }
  },
  methods: {
    dateFormat: function dateFormat(d) {
      return __WEBPACK_IMPORTED_MODULE_0_fecha___default.a.format(new Date(d), 'DD.MM.YYYY');
    },
    anchor: function anchor(id) {
      return '#' + id;
    },
    active: function active(id) {
      return id === this.current ? 'router-link-active' : false;
    },
    waypointIn: function waypointIn(id) {
      if (id % 2) return;
      this.current = id;
    },
    canAdvance: function canAdvance(idx) {
      return idx < this.posts.length - 1;
    },
    prev: function prev() {
      var el = this.anchors[this.current - 2];
      if (!el) return;

      el.scrollIntoView({
        block: 'start',
        behavior: 'smooth'
      });
    },
    advance: function advance() {
      var el = this.anchors[this.current + 2];
      if (!el) {
        var top = this.anchors[0];
        if (!top) return;
        top.scrollIntoView({
          block: 'start',
          behavior: 'smooth'
        });
        return;
      }

      el.scrollIntoView({
        block: 'start',
        behavior: 'smooth'
      });
    }
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    __WEBPACK_IMPORTED_MODULE_1__store___default.a.dispatch('getPosts').then(function () {
      next();
    });
  }
});

/***/ }),

/***/ "nnUm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"line-height-2 fixed left-0 top-0 col-12 z-20 overflow-auto",class:{'bg-white full-height': _vm.smMenu, 'lg-hover-states': _vm.notIndex}},[_c('div',{staticClass:"flex flex-wrap"},[_c('h1',{staticClass:"m0 h3 regular"},[_c('router-link',{staticClass:"no-change",attrs:{"to":"/"}},[_vm._v(_vm._s(_vm.title))])],1),_vm._v(" "),_c('div',{staticClass:"flex-auto right-align sm-hide md-hide lg-hide"},[_c('button',{staticClass:"m0 p0 border-none h2 pointer no-select menu-button",on:{"click":_vm.toggleMenu}},[_vm._v(_vm._s(_vm.buttonIcon))])]),_vm._v(" "),_c('ul',{staticClass:"col-12 sm-flex-auto list-reset m0 sm-pl3 pt2 sm-pt0",class:{ 'xs-hide': !_vm.smMenu }},[_vm._l((_vm.menu),function(page){return [_c('router-link',{staticClass:"h3 mb1 sm-mb0 sm-inline-block sm-pr3 lg-hover-active",attrs:{"to":page.url,"tag":"li","exact":""}},[_c('a',[_vm._v(_vm._s(page.title))])])]})],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "sl25":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Gallery_vue__ = __webpack_require__("HKjq");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d0f977ae_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Gallery_vue__ = __webpack_require__("6oYQ");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Gallery_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d0f977ae_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Gallery_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ukYY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  GOT_PROJECTS: function GOT_PROJECTS(state, data) {
    state.projects = data;
  },
  GOT_PROJECT: function GOT_PROJECT(state, project) {
    var slug = project.slug;

    state.projects[slug] = project;
  },
  SELECT_PROJECT: function SELECT_PROJECT(state, slug) {
    state.currentProject = state.projects[slug];
  },
  GOT_PAGE: function GOT_PAGE(state, page) {
    var post_name = page.post_name;

    state.pages[post_name] = page;
  },
  SELECT_PAGE: function SELECT_PAGE(state, slug) {
    state.currentPage = state.pages[slug];
  },
  GOT_POSTS: function GOT_POSTS(state, posts) {
    state.posts = posts;
  },
  setIntroVisible: function setIntroVisible(state, visible) {
    state.introVisible = visible;
  }
};

/***/ }),

/***/ "wa3q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Project_vue__ = __webpack_require__("Kw7b");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b20425d0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Project_vue__ = __webpack_require__("CjOB");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Project_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b20425d0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Project_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_partials_AppHeader__ = __webpack_require__("SyDD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_partials_AppFooter__ = __webpack_require__("TYs3");
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  metaInfo: { title: 'Maich Swift Architects' },
  components: { AppHeader: __WEBPACK_IMPORTED_MODULE_0__components_partials_AppHeader__["a" /* default */], AppFooter: __WEBPACK_IMPORTED_MODULE_1__components_partials_AppFooter__["a" /* default */] }
});

/***/ }),

/***/ "zIgt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__store__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'intro-screen',
  props: {
    page: Object
  },
  computed: {
    visible: {
      get: function get() {
        return __WEBPACK_IMPORTED_MODULE_0__store___default.a.state.introVisible;
      },
      set: function set(val) {
        __WEBPACK_IMPORTED_MODULE_0__store___default.a.commit('setIntroVisible', val);
      }
    },
    image: function image() {
      if (!this.page || !this.page.acf) return;
      return this.page.acf.logo;
    },
    spin: function spin() {
      if (!this.page || !this.page.acf) return;
      return this.page.acf.spin;
    },
    duration: function duration() {
      if (!this.page || !this.page.acf) return;
      return this.page.acf.duration;
    },
    text: function text() {
      if (!this.page || !this.page.acf) return;
      return this.page.acf.intro_text;
    },
    color: function color() {
      if (!this.page || !this.page.acf) return;
      return this.page.acf.color || 'black';
    },
    bg: function bg() {
      if (!this.page || !this.page.acf) return;
      return this.page.acf.bg_image;
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (!this.page || !this.page.acf) {
      this.visible = false;
      return;
    }

    setTimeout(function () {
      _this.visible = false;
    }, this.duration || 3000);
  }
});

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.08c7443b6617ed1f02cc.js